/** This has been borrowed from other place that we detect mobile
 * maybe later we can add listener to make it responsive this approach is adaptive
 */
const isMobile = window.innerWidth <= 500
export default isMobile
